<div class="p-3" style="border-color: #3b82f6">
  <div class="flex">
    <div class="font-semibold mb-4 inline-block">{{ "global.attributes" | translate }}</div>
  </div>
  <div class="grid">
    <div class="col-5 font-bold">
      <div class="line-wrapper">
        <span>{{ "importWorkflow.vendorAttributes" | translate }}</span>
        <div class="line"></div>
      </div>
    </div>
    <div class="col-7 font-bold">
      <div class="line-wrapper">
        <div>{{ "importWorkflow.propositions" | translate }}</div>
        <div class="line"></div>
      </div>
    </div>
    @for (node of displayedNodes; track $index) {
      <div class="col-5 m-auto">
        <div class="line-wrapper">
          <span>{{ node?.vendorAttribute }} </span>
          <div class="line"></div>
        </div>
      </div>
      <div class="col-5 m-auto">
        <div class="flex">
          <div class="flex-auto" (click)="customAttributeSelection(node)">
            <input
              [(ngModel)]="node.mappedAttribute"
              class="w-full"
              type="text"
              pInputText
              placeholder="{{ 'mapping.chooseAttribute' | translate }}"
              [disabled]="node.associated" />
          </div>
          <div class="flex-initial ml-2">
            <p-button icon="pi pi-pencil" [outlined]="true" (onClick)="customAttributeSelection(node)"></p-button>
          </div>
          @if(node?.localized || node?.locale != "") {
            <div class="pl-1">
              <p-select
              [(ngModel)]="node.selectedLocale"
              [options]="locales"
              [ngModelOptions]="{ standalone: true }"
              class="w-full"
              [disabled]="locales.length == 1"
              (ngModelChange)="updateLocale($event, node)"></p-select>
            </div>
          }
         
        </div>
      </div>
      <div class="col-2 text-right">
        <div class="line-wrapper">
          <div class="line text-500"></div>
          @if (node.associated) {
            <p-button [severity]="'success'" [disabled]="true">
              <i class="pi pi-check mr-1"></i> {{ "buttons.associated" | translate }}
            </p-button>
          } @else {
            <p-button (click)="assiciate(node)" [disabled]="node.mappedAttribute == ''">
              <i class="pi pi-link mr-1"></i> {{ "buttons.associate" | translate }}
            </p-button>
          }
        </div>
      </div>
    }
  </div>
  <div class="flex justify-content-center mt-5">
    <p-paginator 
        (onPageChange)="onPageChange($event)" 
        [first]="first" 
        [rows]="rowsPaginator" 
        [totalRecords]="totalRecordsPaginator" 
        [rowsPerPageOptions]="[10, 30, 50, 100]" />
  </div>
</div>
<p-dialog
  [(visible)]="showModal"
  header="{{ 'mapping.chooseAttribute' | translate }}"
  [dismissableMask]="false"
  [modal]="true"
  [style]="{ width: '45rem', height: '70rem' }"
  draggable="false">
  <div class="pb-3">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        type="text"
        pInputText
        (keydown.enter)="filterGlobal($event)"
        placeholder="{{ 'settings.searchUser' | translate }}"
        class="w-full block" />
    </p-iconField>
  </div>
  <p-table
    [columns]="cols"
    [value]="attributes"
    selectionMode="single"
    [(selection)]="selectedAttribute"
    class="table-modal"
    [rows]="100"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    [totalRecords]="totalRecords"
    paginator="true"
    frozenfooter="true"
    [scrollable]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [id]="col.header">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-columns="columns">
      <tr [pSelectableRow]="product">
        <td *ngFor="let col of columns">
          {{ product[col.field] }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <p-button
      label="{{ 'buttons.cancel' | translate }}"
      [outlined]="true"
      severity="secondary"
      (onClick)="showModal = false" />
    <p-button
      label="{{ 'buttons.confirm' | translate }}"
      (onClick)="mapAttribute()"
      [outlined]="true"
      severity="secondary" />
  </ng-template>
</p-dialog>
